'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isElementInteractive(element) {
  var interactiveTags = ['A', 'BUTTON'];
  var role = element.getAttribute('role');
  var togglerAttr = element.getAttribute('data-menuToggler');
  var togglerIgnoreAttr = element.getAttribute('data-menuTogglerIgnore');
  var tag = element.tagName;

  return !togglerIgnoreAttr && !togglerAttr && (interactiveTags.includes(tag) || role === 'button');
}

/**
 * Menu Toggler HoC.
 * set menu using activateMenu(String) call again to toggle off
 * check if menu is active using isActiveMenu(String)
 */
function menuToggler(WrappedComponent) {
  return function (_React$Component) {
    (0, _inherits3.default)(MenuToggleComponent, _React$Component);

    function MenuToggleComponent(props) {
      (0, _classCallCheck3.default)(this, MenuToggleComponent);

      var _this = (0, _possibleConstructorReturn3.default)(this, (MenuToggleComponent.__proto__ || (0, _getPrototypeOf2.default)(MenuToggleComponent)).call(this, props));

      _this.closeMenu = function (event) {
        if (_this.ref && (!_this.ref.isSameNode(event.target) && !_this.ref.contains(event.target) || !_this.ref.isSameNode(event.target) && _this.ref.contains(event.target) && isElementInteractive(event.target)) && _this.state.activeMenu) {
          _this.setState({
            activeMenu: null
          });
        }
      };

      _this.activateMenu = function (menu) {
        return function (event) {
          if (event.which && ![13, 32].includes(event.which)) {
            return;
          }
          event.target.setAttribute('data-menuToggler', true);
          var activeMenu = null;
          if (_this.state.activeMenu !== menu) {
            activeMenu = menu;
          }
          _this.setState({
            activeMenu: activeMenu
          });
        };
      };

      _this.isActiveMenu = function (menu) {
        return _this.state.activeMenu === menu;
      };

      _this.state = {
        activeMenu: null
      };
      return _this;
    }

    (0, _createClass3.default)(MenuToggleComponent, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        document.addEventListener('click', this.closeMenu);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        document.removeEventListener('click', this.closeMenu);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement(
          'div',
          { ref: function ref(_ref) {
              _this2.ref = _ref;
            } },
          _react2.default.createElement(WrappedComponent, (0, _assign2.default)({}, this.props, {
            activateMenu: this.activateMenu,
            isActiveMenu: this.isActiveMenu
          }))
        );
      }
    }]);
    return MenuToggleComponent;
  }(_react2.default.Component);
}

exports.default = menuToggler;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/menuToggler.js
// module id = 513
// module chunks = 0